export default "__VITE_ASSET__BJ7Qcz8d__"